export const apiLinks = () => {
    return {
        env: 'development',
        url: 'https://dev-api.apply.credicorp-register.ng/credit-corp-backend-production/api/v1/',
        awsKey: 'development/programmeFiles/',
        applicationLink: 'https://dev.apply.credicorp-register.ng/apply',
        homeLink: 'https://dev.credicorp-register.ng'
    };
}